import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import ReactDOMServer from "react-dom/server";
import { Link, useLocation, useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//services
import { getSimulation } from "../../../../../../services/Contracts/getSimulation";
import { useAppContext } from "../../../../../../context/AppContext";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { format, parseISO } from "date-fns";
import { useContextSimulator } from "../../../Simulator/SimulatorContext";
import { postSale } from "../../../../../../services/Simulator/postSale";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { getParcelDescription } from "../../../../../../services/GlobalRoles/getParcelDescription";
import Select from "../../../../../../components/input/Select";
import { Dropdown } from "primereact/dropdown";

export const Simulation = () => {

  const { state } = useLocation();
  const navigate = useNavigate();
  const { calculatePricePayment, calculateSACPayments, calculateSACOCPayments, calculateInterestFreePayments } = useContextSimulator();
  const [loadingButton, setLoadingButton] = useState(false);
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const [entryValue, setEntryValue] = useState(null);
  const [entryInterest, setEntryInterest] = useState(null);

  const [financingValue, setFinancingValue] = useState(null);
  const [financingInterest, setFinancingInterest] = useState(null);

  const [intermediateValue, setIntermediateValue] = useState(0);
  const [intermediateInterest, setIntermediateInterest] = useState(null);

  const [constructionValue, setConstructionValue] = useState(0);
  const [constructionInterest, setConstructionInterest] = useState(null)

  const [entryInstallments, setEntryInstallments] = useState(null);
  const [financingInstallments, setFinancingInstallments] = useState(null);
  const [intermediateInstallments, setIntermediateInstallments] = useState(null);
  const [constructionInstallments, setConstructionInstallments] = useState(null);
  const [signalInstallments, setSignalInstallments] = useState(null);
  const [uniqueInstallmentDate, setUniqueInstallmentDate] = useState(null);
  const [singleInstallments, setSingleInstallments] = useState(null);

  const [parcelDesc, setParcelDesc] = useState([]);
  const [selectedParcelDesc, setSelectedParcelDesc] = useState(1);
  
  const { data, isLoading } = useQuery({
    queryKey: [`simulation_${state.id}`],
    queryFn: () => getSimulation(state.id),
    enabled: !!permissions?.includes("25")
  });

  const {
    data: parcelDescription,
    isLoading: isParcelDescLoading,
  } = useQuery({
    queryKey: ["parcelDescription"],
    queryFn: () => getParcelDescription(),
    enabled: !!permissions?.includes("140"),
  });

  const item = [
    {
      label: "Negociações",
      template: () => (
        <Link
          to={`/negotiations/${state.enterpriseId.id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Negociações
        </Link>
      ),
    },
    {
      label: "Proposta",
      template: () => (
        <Link
          to={`/simulation`}
          state={{ id: state.id, enterpriseId: state.enterpriseId }}
          className="p-breadcrumb-link"
        >
          Simulação
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const taxCalc = async (pricingTable, value, rate, term) => {
    let result;
    switch (pricingTable) {
      case "price":
        result = await calculatePricePayment(value, rate, term);
        break;
      case "sac":
        result = await calculateSACPayments(value, rate, term);
        break;
      case "sacoc":
        result = await calculateSACOCPayments(value, rate, term);
        break;
      case "interest_free":
        result = await calculateInterestFreePayments(value, term);
        break;
      default:
        break;
    }
    return result;
  };

  useEffect(() => {
    if (data) {
      // console.log(data);
      if (data.config.entry_value) {
        const interest = data.config.entry_value_rate ? data.config.entry_value_rate : 0;
        setEntryValue(parseFloat(interest) + parseFloat(data.config.entry_value));
        setEntryInterest(parseFloat(interest));
      }

      if (data.config.financing_value) {
        // console.log("data.config.amortization_system: ", data.config.amortization_system);
        // console.log("parseFloat(data.config.financing_value).toFixed(2): ", parseFloat(data.config.financing_value).toFixed(2));
        // console.log("data.config.financing_rate / 100,: ", data.config.financing_rate / 100,);
        // console.log("data.config.number_financing_installments: ", data.config.number_financing_installments);
        taxCalc(
          data.config.amortization_system,
          parseFloat(data.config.financing_value).toFixed(2),
          data.config.financing_rate / 100,
          data.config.number_financing_installments
        ).then((res) => {
          //          // console.log(res);
          setFinancingValue(
            parseFloat(res.totalInterest) +
            parseFloat(data.config.financing_value)
          );
          setFinancingInterest(parseFloat(res.totalInterest));
        });
      }

      if (data.installments) {
        // console.log(data.installments)
        const entryInstallments = [];
        const financingInstallments = [];
        const intermediateInstallments = [];
        const constructionInstallments = [];
        const uniqueInstallment = [];
        const signalInstallment = [];

        data.installments.forEach((p) => {
          const {
            due_date,
            value,
            sequence_number,
            installment_description_id,
            obs_sale
          } = p;
          //          // console.log(new Date(due_date));
          //          // console.log(typeof new Date(due_date));
          const formattedValue = formatCurrency(value);
          const formattedDate = format(parseISO(due_date), "dd/MM/yyyy");
          const installment = {
            due_date: formattedDate,
            value: formattedValue,
            sequence_number,
            obs_sale
          };

          switch (installment_description_id) {
            case 1:
              //              // console.log("Installment Entry: ", installment);
              entryInstallments.push(installment);
              break;
            case 2:
              //              // console.log("Installment Financ: ", installment);
              financingInstallments.push(installment);
              break;
            case 3:
              //              // console.log("Installment Intermed: ", installment);
              intermediateInstallments.push(installment);
              break;
            case 4:
              //              // console.log("Installment Parcela Unica: ", installment);
              uniqueInstallment.push(installment);
              setUniqueInstallmentDate(installment.due_date);
              break;
            case 5:
              //              // console.log("Installment Parcela Sinal: ", installment);
              signalInstallment.push(installment);
              break;
            case 6:
              //              // console.log("Installment Const: ", installment);
              constructionInstallments.push(installment);
              break;
            default:
              break;
          }
        });

        // Agora você tem dois arrays separados, entryInstallments e financingInstallments,
        // que contêm objetos com base no installment_description_id.
        // Você pode definir esses arrays de estado conforme necessário.
        setEntryInstallments(entryInstallments);
        setFinancingInstallments(financingInstallments);
        setIntermediateInstallments(intermediateInstallments);
        setConstructionInstallments(constructionInstallments);
        setSingleInstallments(uniqueInstallment);
        setSignalInstallments(signalInstallment);
      }
    }
  }, [data]);

  useEffect(() => {
    // console.log("Entry: ", entryInstallments);
    // console.log("Financing: ", financingInstallments);
    // console.log("Intermediate: ", intermediateInstallments);
    // console.log("Construction: ", constructionInstallments);
    // console.log("data.config: ", data);

    if (data && data.config.intermediate_value && intermediateInstallments) {
      const interest = data.config.intermediate_value_rate ? data.config.intermediate_value_rate : 0;

      // let amortization = 0; // Inicializando amortization com zero
      // intermediateInstallments.forEach(i => {
      //   let numeroLimpo = i.value.replace(/[^\d,-]/g, '');
      //   numeroLimpo = numeroLimpo.replace(',', '.');

      //   const numericValue = parseFloat(numeroLimpo); // Convertendo para número
      //   amortization += numericValue; // Adicionando ao total
      // });
      // console.log("amortization dos valores:", amortization);
      // setIntermediateValue(parseFloat(amortization));
      // setIntermediateInterest(parseFloat(data.config.intermediate_value) - parseFloat(amortization));

      setIntermediateInterest(parseFloat(interest));
      setIntermediateValue(parseFloat(data.config.intermediate_value));
    }

    if (data && data.config.construction_value && constructionInstallments) {
      const interest = data.config.construction_value_rate ? data.config.construction_value_rate : 0;

      // let amortization = 0; // Inicializando amortization com zero
      // constructionInstallments.forEach(i => {
      //   let numeroLimpo = i.value.replace(/[^\d,-]/g, '');
      //   numeroLimpo = numeroLimpo.replace(',', '.');

      //   const numericValue = parseFloat(numeroLimpo); // Convertendo para número
      //   amortization += numericValue; // Adicionando ao total
      // });
      // console.log("amortization dos valores C:", amortization);

      setConstructionValue(parseFloat(interest) + parseFloat(data.config.construction_value));
      setConstructionInterest(parseFloat(interest));
    }
  }, [financingInstallments, entryInstallments, intermediateInstallments, constructionInstallments]);

  useEffect(() => {
    if (parcelDescription) {
      console.log(parcelDescription)
      const parcelDescriptions = parcelDescription.map((pd) => ({
        value: pd.id,
        label: pd.description,
      }));
      console.log(parcelDescriptions);
      setParcelDesc(parcelDescriptions);
    }
  }, [parcelDescription]);

  const handleSimulationAction = async (id) => {
    confirmDialog({
      message: "Deseja enviar a simulação para proposta?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => handleAccept(id),
    });
  }

  console.log(data)

  const handleAccept = async (id) => {
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    // console.log(id);
    const data = {
      simulation_id: id,
    }
    try {
      await postSale(data)
      toast.update(notification, {
        render: "Simulação enviada para avaliação",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
      navigate(`/negotiations/${state.enterpriseId.id}`, { state: { name: state ? state.name : "Empreendimento" } })
    } catch (error) {
      toast.update(notification, {
        render: error.response.data.error ? error.response.data.error : "Oops algo deu errado, tente novamente mais tarde.",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false)
    }
  }

  const handlePrint = () => {
    const content = <Invoice print={true} />;
    const htmlString = ReactDOMServer.renderToString(content);

    const options = {
      margin: 18,
      filename: `Simulação de Compra / ${data.enterprise} - ${nomenclature[0].value} ${data.info.block} ${nomenclature[1].value} ${data.info.land}`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "letter", orientation: "portrait" },
    };

    const addPageNumbers = (pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Página ${i} de ${totalPages}`,
          pdf.internal.pageSize.getWidth() - 100,
          pdf.internal.pageSize.getHeight() - 30
        );
      }
    };

    const generatePDF = () => {
      // const pdf = new jsPDF(options.jsPDF);
      html2pdf()
        .from(htmlString)
        .set(options)
        .toPdf()
        .get("pdf")
        .then(function (pdfDoc) {
          addPageNumbers(pdfDoc);
          pdfDoc.save(options.filename);
        });
    };

    generatePDF();
    toast.success("PDF Pronto!");
  };

  function formatToWrittenDate(dataString) {
    const meses = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    const data = new Date(dataString);
    const dia = data.getDate();
    const mes = meses[data.getMonth()];
    const ano = data.getFullYear();

    return `${dia} de ${mes} de ${ano}`;
  }

  const Invoice = ({ print }) => (
    <div className="invoice">
      <div className="invoice-company">
        {!print && (
          <span className="float-end hidden-print">
            <button
              className="btn btn-sm btn-white mb-10px me-2"
              onClick={() => handlePrint()}
            >
              <i className="fa fa-file-pdf t-plus-1 text-danger fa-fw fa-lg"></i>{" "}
              Baixar como PDF
            </button>
          </span>
        )}
        {data.enterprise} / {nomenclature[0].label}: {data.info.block} - {nomenclature[1].label}: {data.info.land}
      </div>
      <div className="invoice-header">
        <div className="invoice-from">
          <small>Cliente</small>
          <address className="mt-5px mb-5px">
            <strong className="text-dark">{data.cli.name}</strong>
            <br />
            CPF: {data.cli.doc}
            {data.cli.address && (
              <>
                <br />
                {data.cli.address.address}, {data.cli.address.num} -{" "}
                {data.cli.address.neighborhood}
                <br />
                {data.cli.address.city}, {data.cli.address.cep}
              </>
            )}
            <br />
            E-mail: {data.cli.email} <br />
            {data.cli.contacts && data.cli.contacts.length > 0 && (
              <>
                Telefone:{" "}
                {data.cli.contacts.map(
                  (c, index) =>
                    `${c.number}${index === data.cli.contacts.length - 1 ? "" : " / "
                    }`
                )}
              </>
            )}
          </address>
        </div>
        {data.broker && (
          <div className="invoice-to">
            <small>Vendedor</small>
            <address className="mt-5px mb-5px">
              <strong className="text-dark">{data.broker.name}</strong>
              <br />
              Registrado por: {data.info.registered_by}
              <br />
              Imobiliária: {data.real_estate.name}
              <br />
              Email: {data.broker.email}
              <br />
              {data.broker.contacts && data.broker.contacts.length > 0 && (
                <>
                  Telefone:{" "}
                  {data.broker.contacts.map(
                    (c, index) =>
                      `${c.number}${index === data.broker.contacts.length - 1 ? "" : " / "
                      }`
                  )}
                </>
              )}
            </address>
          </div>
        )}
        <div className="invoice-date">
          <small>Data da Proposta</small>
          <div className="date text-dark mt-5px">
            {formatToWrittenDate(data.config.created_at)}
          </div>
          <div className="invoice-detail">
            Proposta de Venda: {String(data.id).padStart(5, "0")}
            {/* <br />
                Services Product */}
          </div>
        </div>
      </div>

      <div className="invoice-content">
        <div className="table-responsive">
          {data && data.config.cash_value ? (
            <table className="table table-invoice">
              <thead>
                <tr>
                  <th className="text-start">PARCELA</th>
                  <th className="text-center" width="20%">
                    VALOR
                  </th>
                  <th className="text-center" width="20%">
                    DATA VENCIMENTO
                  </th>
                </tr>
              </thead>
              <tbody>
                {data && data.installments.map((o) => (
                  <tr key={o.sequence_number}>
                    <td>{o.sequence_number}</td>
                    <td className="text-center">{formatCurrency(o.value)}</td>
                    <td className="text-center">{format(parseISO(o.due_date), "dd/MM/yyyy")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <table className="table table-invoice">
              <thead>
                <tr>
                  <th className="text-start">DESCRIÇÃO</th>
                  <th className="text-start">QUANTIDADE PARCELAS</th>
                  <th className="text-start">VALOR SEM JUROS</th>

                  <th className="text-start">VALOR JUROS</th>

                  <th className="text-start">VALOR COM JUROS</th>

                  <th className="text-end" width="20%">
                    VENCIMENTO PRIMEIRA PARCELA
                  </th>
                </tr>
              </thead>
              <tbody>
                {entryValue && (
                  <tr>
                    <td>
                      {/* {data.status === 0 && !!permissions?.includes("140") ? (
                        <>
                            <Dropdown
                              showClear
                              className={`w-100`}
                              id="parcel_desc"
                              name="parcel_desc"
                              value={selectedParcelDesc}
                              options={parcelDesc || []}
                              emptyFilterMessage="Nenhuma informação encontrada."
                              emptyMessage="Nenhuma informação encontrada."
                              onChange={(e) => setSelectedParcelDesc(e.value)}
                            />
                        </>
                      ) : ( */}
                        <span className="text-dark">Entrada</span>
                    </td>
                    <td>
                      {String(data.config.number_entry_installments).padStart(
                        3,
                        "0"
                      )}
                    </td>
                    <td>{formatCurrency(data.config.entry_value)}</td>
                    <td>{formatCurrency(entryInterest)}</td>
                    <td>{formatCurrency(entryValue)}</td>
                    <td className="text-end">{entryInstallments && entryInstallments[0].due_date}</td>
                    {/* <td className="text-end">{entryInstallments && format(new Date(entryInstallments[0].due_date), "dd/MM/yyyy")}</td> */}
                  </tr>
                )}
                {data.config.single_value && (
                  <tr>
                    <td>
                      <span className="text-dark">Parcela Única</span>
                    </td>
                    <td>
                      {String("1").padStart(
                        3,
                        "0"
                      )}
                    </td>
                    <td>{formatCurrency(data.config.single_value)}</td>
                    <td>R$ 0,00</td>
                    <td>{formatCurrency(data.config.single_value)}</td>
                    <td className="text-end">{uniqueInstallmentDate && uniqueInstallmentDate}</td>
                    {/* <td className="text-end">{uniqueInstallmentDate && format(new Date(uniqueInstallmentDate), "dd/MM/yyyy")}</td> */}
                  </tr>
                )}
                {constructionValue !== 0 && (
                  <tr>
                    <td>
                      <span className="text-dark">Construção</span>
                    </td>
                    <td>
                      {String(data.config.number_construction_installments).padStart(
                        3,
                        "0"
                      )}
                    </td>
                    <td>{formatCurrency(data.config.construction_value)}</td>
                    <td>{formatCurrency(constructionInterest)}</td>
                    <td>{formatCurrency(constructionValue)}</td>
                    <td className="text-end">{constructionInstallments && constructionInstallments[0].due_date}</td>
                    {/* <td className="text-end">{constructionInstallments && format(new Date(constructionInstallments[0].due_date), "dd/MM/yyyy")}</td> */}
                  </tr>
                )}
                {intermediateValue !== 0 && (
                  <tr>
                    <td>
                      <span className="text-dark">Intermediarias</span>
                    </td>
                    <td>
                      {String(data.config.number_intermediate_installments).padStart(
                        3,
                        "0"
                      )}
                    </td>
                    <td>{formatCurrency(parseFloat(intermediateValue) - intermediateInterest)}</td>
                    <td>{formatCurrency(intermediateInterest)}</td>
                    <td>{formatCurrency(data.config.intermediate_value)}</td>
                    <td className="text-end">{intermediateInstallments && intermediateInstallments[0].due_date}</td>
                    {/* <td className="text-end">{intermediateInstallments && format(new Date(intermediateInstallments[0].due_date), "dd/MM/yyyy")}</td> */}
                  </tr>
                )}
                {financingValue && (
                  <tr>
                    <td>
                      <span className="text-dark">Financiamento</span>
                    </td>
                    <td>
                      {String(data.config.number_financing_installments).padStart(
                        3,
                        "0"
                      )}
                    </td>
                    <td>{formatCurrency(data.config.financing_value)}</td>
                    <td>{formatCurrency(financingInterest)}</td>
                    <td>{formatCurrency(financingValue)}</td>
                    <td className="text-end">{financingInstallments && financingInstallments[0].due_date}</td>
                    {/* <td className="text-end">{financingInstallments && format(new Date(financingInstallments[0].due_date), "dd/MM/yyyy")}</td> */}
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
        <div className="invoice-price">
          <div className="invoice-price-left">
            <div className="invoice-price-row">
              {/* {intermediateValue !== 0 && entryValue !== 0 && financingValue !== 0 ? (
                <></>
              ) : (
                <>
                  {entryValue && (
                    <>
                      <div className="sub-price">
                        <small>ENTRADA</small>
                        <span className="text-dark">
                          {formatCurrency(entryValue)}
                        </span>
                      </div>
                      <div className="sub-price">
                        <i className="fa fa-plus text-muted"></i>
                      </div>
                    </>
                  )}
                  {financingValue && (
                    <div className="sub-price">
                      <small>FINANCIAMENTO</small>
                      <span className="text-dark">
                        {formatCurrency(financingValue)}
                      </span>
                    </div>
                  )}
                </>
              )} */}
            </div>
          </div>
          <div className="invoice-price-right">
            <small>Total</small>{" "}
            <span className="fw-bold">
              {data && data.config.cash_value ? (
                formatCurrency(parseFloat(data.config.cash_value))
              ) : (
                formatCurrency(
                  entryValue
                  + financingValue
                  + parseFloat(intermediateValue)
                  + parseFloat(constructionValue)
                  + (data.config.single_value ? parseFloat(data.config.single_value) : 0))
              )}
            </span>
          </div>
        </div>
      </div>

      {entryInstallments && entryInstallments.length > 0 && (
        <div className="invoice-parcels my-5">
          <h4>Parcelas de Entrada</h4>
          <hr />
          {print ? (
            <DataTable stripedRows value={entryInstallments} size={"small"}>
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
              <Column field="obs_sale" header="Observação"></Column>
            </DataTable>
          ) : (
            <DataTable
              stripedRows
              value={entryInstallments}
              size={"small"}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            >
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
              <Column field="obs_sale" header="Observação"></Column>
            </DataTable>
          )}
        </div>
      )}

      {signalInstallments && signalInstallments.length > 0 && (
        <div className="invoice-parcels my-5">
          <h4>Parcelas Sinal</h4>
          <hr />
          {print ? (
            <DataTable stripedRows value={signalInstallments} size={"small"}>
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
            </DataTable>
          ) : (
            <DataTable
              stripedRows
              value={signalInstallments}
              size={"small"}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            >
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
            </DataTable>
          )}
        </div>
      )}

      {constructionInstallments && constructionInstallments.length > 0 && (
        <div className="invoice-parcels my-5">
          <h4>Parcelas Construção</h4>
          <hr />
          {print ? (
            <DataTable stripedRows value={constructionInstallments} size={"small"}>
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
            </DataTable>
          ) : (
            <DataTable
              stripedRows
              value={constructionInstallments}
              size={"small"}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            >
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
            </DataTable>
          )}
        </div>
      )}

      {intermediateInstallments && intermediateInstallments.length > 0 && (
        <div className="invoice-parcels my-5">
          <h4>Parcelas Intermediarias</h4>
          <hr />
          {print ? (
            <DataTable stripedRows value={intermediateInstallments} size={"small"}>
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
            </DataTable>
          ) : (
            <DataTable
              stripedRows
              value={intermediateInstallments}
              size={"small"}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            >
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
            </DataTable>
          )}
        </div>
      )}

      {financingInstallments && financingInstallments.length > 0 && (
        <div className="invoice-parcels mb-5">
          <h4>Parcelas de Financiamento</h4>
          <hr />
          {print ? (
            <DataTable stripedRows value={financingInstallments} size={"small"}>
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
            </DataTable>
          ) : (
            <DataTable
              stripedRows
              value={financingInstallments}
              size={"small"}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            >
              <Column field="sequence_number" header="Parcela"></Column>
              <Column field="value" header="Valor"></Column>
              <Column field="due_date" header="Data pagamento"></Column>
            </DataTable>
          )}
        </div>
      )}

      <div className="invoice-footer">
        <p className="text-center mb-5px fw-bold">{data.name_enterprise}</p>
        {/* <p className="text-center">
              <span className="me-10px">
                <i className="fa fa-fw fa-lg fa-globe"></i> matiasgallipoli.com
              </span>
              <span className="me-10px">
                <i className="fa fa-fw fa-lg fa-user"></i>CRESCI:23544254353
              </span>
              <span className="me-10px">
                <i className="fa fa-fw fa-lg fa-envelope"></i> corretor@gmail.com
              </span>
            </p> */}
      </div>
    </div>
  );

  return (
    <>
      {data && !isLoading && !isParcelDescLoading ? (
        <div>
          <div className="row d-flex justify-content-between mb-3">
            <div className="col-md-4">
              <BreadCrumb model={item} className="breadCrumb" home={home} />
            </div>
            {data.status === 0 && permissions && permissions.includes("31") && ( //Enviar Proposta 
              <div className="col-md-8 text-end">
                <Button
                  label="Enviar proposta"
                  icon={"fa-solid fa-check"}
                  iconPos="right"
                  onClick={() => handleSimulationAction(data.id)}
                  loading={loadingButton}
                />
              </div>
            )}
          </div>
          <Invoice print={false} />
        </div>
      ) : (
        <Skeleton width="100%" height="500px"></Skeleton>
      )}
    </>
  );
};
